import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Endpoints } from '../../../models/endpoints';
import { Profiles } from '../models/profiles';
import { HttpService } from '../../shared/services/http.service';


@Injectable({
  providedIn: 'root'
})
export class HabilitationService {

  constructor(private http: HttpService) { }

  public getProfiles(): Observable<Profiles> {
    return this.http.get(Endpoints.HABILITATION, Profiles, { basePath: environment.piste_hab_base_url });
  }
}
